import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Validators, UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfirmationDialog } from 'src/app/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, CdkDropList } from '@angular/cdk/drag-drop';
import { PlantService } from '../plant.service';
import { DeltaButtonPayload, DeltaService, SubAssemblyDelta } from './delta.service';
import { ConfigColumn} from './configColumn.model';
import { ConfigValue} from './configValue.model';
import { MatTabChangeEvent, MatTabGroup, MatTab } from '@angular/material/tabs';
import { Globals } from '../../app.globals';
import {GeaMesCognitoAuthService } from '@gea-mes/cognito';
import {Subscription } from 'rxjs';
import {first } from 'rxjs/operators';        
import { Plant } from '../plant.model';
import { MatFormField, MatLabel, MatHint, MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgFor, NgStyle, NgIf } from '@angular/common';
import { MatAnchor, MatButton } from '@angular/material/button';


type ValueColumnName = 'C1Value' | 'C2Value' | 'C3Value' | 'C4Value' | 'C5Value';

@Component({
    selector: 'app-delta',
    templateUrl: './delta.component.html',
    styleUrls: ['./delta.component.css'],
    imports: [MatTabGroup, MatTab, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, NgFor, MatHint, MatAnchor, NgStyle, NgIf, CdkDropList, MatButton, MatInput]
})
export class DeltaComponent implements OnInit {
  plantControl!: UntypedFormGroup;
  deltaNameContrl!: UntypedFormGroup;
  valueTableHeader: string[] = [];
  subAsssemblyDeltaData: SubAssemblyDelta[] = [];
  showTable:boolean=false;
  tempObj:any={};
  update:any = [];
  subAsseblySortedData:any ={};
  activeTabIndex:number=0;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  columnConfigDisbale:boolean=true;
  valueConfigDisbale:boolean=true;
  deltaButtonName = '';
  dynamicButtonTableShow:boolean=false;
  statusCode:any;
  adminSub$?: Subscription;

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public plantService: PlantService,
    public deltaservice: DeltaService,
    public _global: Globals,
    public geaMesCognitoAuthService: GeaMesCognitoAuthService

  ) { }

  ngOnInit() {

    this.plantControl = this.fb.group({
      plantControl: [null, Validators.required]
    });

    this.deltaNameContrl=this.fb.group({
      deltaName:[null]
    });

    if (this.plantService.selectedPlant != undefined) {
      this.plantService.aSynchRefreshList().subscribe(data => {
        this.plantControl.get('plantControl')?.setValue(this.plantService.selectedPlant);
        this.getData();
        this.activeTabIndex=this.deltaservice.lastActivatedTab;
      });
    } else {
      this.plantService.refreshList();
    }

   this.deltaservice.selectedColumnConfig=undefined;
   this.deltaservice.selectedValueConfig=undefined;

   this.adminSub$ = this.geaMesCognitoAuthService.isUserInRole("Admin").pipe(first()).subscribe( out => {
    this._global.admin = out;
    if (this.adminSub$) this.adminSub$.unsubscribe();
  });

  }


  onPlantSelect() {
    const plant = this.plantControl.get('plantControl')?.value as Plant | null;
    if (!plant) {
      return;
    }
    this.plantService.setSelectedPlant(plant);
    this.getData();
  }

  compareByValue(f1: any, f2: any) {
    return f1 && f2 && f1.name === f2.name;
  }

  compareFn: ((f1: any, f2: any) => boolean) | null = this.compareByValue;

  formatData(data: SubAssemblyDelta[]) {
    const columnData = data[0]?.SubFreeFormValue ?? [];
    if(columnData.length === 5){
      this.columnConfigDisbale=true;
    }else{
      this.columnConfigDisbale=false;
    }
    if(columnData.length > 0){
      this.valueConfigDisbale=false;
    }else{
      this.valueConfigDisbale=true;
    }
    this.valueTableHeader=[];
    if(columnData.length > 0){
      this.valueTableHeader.push('Name');
      this.valueTableHeader.push('Display Name');
      this.valueTableHeader.push('Display Order');
      columnData.forEach(element => {
        this.valueTableHeader.push(element.name);
      });
      this.valueTableHeader.push('Rollup');
      this.showTable=true;
    }else{
      this.showTable=false;
      this._snackBar.open("No Data", "", {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
    }

  }

  onColumnConfigsSelect(columnconfig: ConfigColumn) {
    this.deltaservice.setSelectedColumnConfig(columnconfig);
    if (this._global.admin) {
      this.router.navigate(["/update-columnConfig"]);
    }
    else {
      this.notAuthorizedMessage();
    }
  }

  createColumnConfig() {
    if (this._global.admin) {
      this.router.navigate(["/create-columnConfig"]);
    }
  }

  onValueConfigsSelect(valueconfig: ConfigValue) {
    this.deltaservice.setSelectedValueConfig(valueconfig);
    if (this._global.admin) {
      this.router.navigate(["/update-valueConfig"]);
    }
    else {
      this.notAuthorizedMessage();
    }
  }

  deleteColumnConfig(row: ConfigColumn, index: number) {
    if (this._global.admin) {
      const dbColumnNames: ValueColumnName[] = ['C1Value', 'C2Value', 'C3Value', 'C4Value', 'C5Value'];
      const dbColumnName = dbColumnNames[index];
      if (!dbColumnName) {
        return;
      }
      const dialogRef = this.dialog.open(ConfirmationDialog, {
        data: {
          message: 'Are you sure want to delete?',
          buttonText: {
            ok: 'Yes',
            cancel: 'No'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          const deleteRequest = { ...row, type: 'delete' };
          const checkValueConfig = this.CheckForValueConfig(this.subAsssemblyDeltaData[0]?.SubFreeFormConfig ?? [], dbColumnName);
          console.log("check check:", checkValueConfig);

          if (checkValueConfig) {
            this._snackBar.open("Please delete the values from value config before deleting column config.", "Faiure", {
              duration: 5000,
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
            });
          } else {
            const a = document.createElement('a');
            a.click();
            a.remove();
            this.deltaservice.deleteColumnConfig(deleteRequest).subscribe(res => {
              if (res.Body.RecordCount > 0) {
                this.showSuccessMessage();
                this.getData();
              } else {
                this.showFailureMessage();
              }
            });
          }

        }
      });
    }

  }

  deleteValueConfig(row: ConfigValue) {
    if (this._global.admin) {
      const dialogRef = this.dialog.open(ConfirmationDialog, {
        data: {
          message: 'Are you sure want to delete?',
          buttonText: {
            ok: 'Yes',
            cancel: 'No'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          const a = document.createElement('a');
          a.click();
          a.remove();
          const deleteRequest = { ...row, type: 'delete' };
          this.deltaservice.deleteValueConfig(deleteRequest).subscribe(res => {
            if (res.Body.RecordCount > 0) {
              this.showSuccessMessage();
              this.getData();
            } else {
              this.showFailureMessage();
            }
          });
        }
      });
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    this.update=[];
    this.subAsseblySortedData={};
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.activeTabIndex=tabChangeEvent.index;
    this.deltaservice.storeActiveTab(this.activeTabIndex);
  }

  showSuccessMessage(){

    this._snackBar.open("Record Deletion Success", " ", {
      duration: 5000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: ['alert-success'],
    });

  }

  showFailureMessage(){
      this._snackBar.open("Record Deletion", "Failure", {
        duration: 5000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
     }

  getData() {
    const plant = this.plantControl.get('plantControl')?.value as Plant | null;
    if (!plant) {
      return;
    }
    this.dynamicButtonTableShow=false;
    this.deltaservice.getSubAssemblyDelta(plant.name).subscribe(res => {
      this.subAsssemblyDeltaData=res;
      this.dynamicButtonTableShow=true;
      this.deltaButtonName = res[0]?.ButtonName?.[0]?.button_name ?? '';
      this.deltaNameContrl.get('deltaName')?.setValue(this.deltaButtonName);
      this.formatData(res);
      this.deltaservice.storeSubAssemblyColumnData(res[0]?.SubFreeFormValue ?? []);
    });
  }

  addNewValueConfig() {
    if (this._global.admin) {
      if (this.subAsssemblyDeltaData[0].SubFreeFormValue.length > 0) {
        this.router.navigateByUrl("/create-valueConfig");
      }
      else {
        this._snackBar.open("Please Configure Column(s) first", "", {
          duration: 5000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
        });
      }
    }
  }

  CheckForValueConfig(valueData: ConfigValue[], columnName: ValueColumnName): boolean {
    return valueData.some(value => String(value[columnName] ?? '').replace(/ /g, '') !== '');
  }

  nameConfigSubmit() {
    if (this._global.admin) {
      const buttonName = String(this.deltaNameContrl.get('deltaName')?.value ?? '').trim();
      const plant = this.plantControl.get('plantControl')?.value as Plant | null;
      if (buttonName === '') {
        this._snackBar.open("Please Enter Sub-Assembly Delta's Name", "", {
          duration: 5000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
        });
      } else if (plant) {
        const jsonData: DeltaButtonPayload = {
          plant_name: plant.name,
          button_name: buttonName
        };
        this.deltaservice.updateDeltaButtonName(jsonData).subscribe(resp => {
          if (resp.Body.RecordCount >= 0) {
            this._snackBar.open("Record Updated Succesfully", "", {
              duration: 5000,
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
              panelClass: ['alert-success'],
            });
          } else {
            this._snackBar.open("Record Updation", "Failure", {
              duration: 5000,
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
            });
          }
        });
      }
    }
  }

  notAuthorizedMessage(){
    this._snackBar.open("USER NOT AUTHORISED", "OK", {
      duration: 0,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
}
